export default __webpack_public_path__ + "static/media/php.4990580e.png";